import { useAuth } from "../../Contexts/AuthContext";
import { Navigate, Outlet } from "react-router-dom";
import LoadingOverlay from "../LoadingOverlay/LoadingOverlay";

const RequireAdmin = () => {
  const { isAdmin, loading } = useAuth();
  if (loading) {
    return <LoadingOverlay fullscreen />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}

export default RequireAdmin;
